<template>
  <div class="contract-procedures w-full md:pt-8">
    <bdg-table-view :rows="activeProcedures" :columns="columns">
      <template #beside-pagination>
        <bdg-button
          class="ghost has-icon w-full md:w-auto uppercase"
          before-icon-class="fal fa-plus-square"
          @click.native="addProcedure"
        >
          add procedure
        </bdg-button>
      </template>
    </bdg-table-view>
  </div>
</template>

<script>
import BdgButton from "../../elements/BdgButton";
import ProcedureForm from "./forms/ProcedureForm";
import BdgTableView from "../../elements/table-view/BdgTableView";
import CheckboxCell from "../../elements/table-view/special-cells/CheckboxCell";

export default {
  name: "ContractProcedures",
  components: { BdgTableView, BdgButton },
  data() {
    return {
      contractId: parseInt(this.$route.params.id, 10),
      columns: [
        { label: "", property: "title" },
        { label: "", property: "checkboxProps", cellComponent: CheckboxCell }
      ]
    };
  },
  computed: {
    procedures() {
      const procedures = this.$store.state.Contracts.Procedures
        .contractProcedures;
      return procedures ? procedures : [];
    },
    activeProcedures() {
      const component = this;
      return this.procedures
        .filter(proc => proc.is_active)
        .map(proc => {
          proc.checkboxProps = {
            label: "Completed",
            value: proc.status === "completed",
            changeHandler(val) {
              component.updateProcedureStatus(proc, val);
            }
          };
          return proc;
        });
    }
  },
  created() {
    this.$store.dispatch("getContractProcedures", this.contractId);
  },
  methods: {
    updateProcedureStatus(procedure, bool) {
      procedure.status = bool ? "completed" : "not-started";
      this.$store.dispatch("updateProcedure", procedure);
    },
    addProcedure() {
      this.$store.commit("setCreateEditComponentParams", {
        createEditComponent: ProcedureForm,
        createEditComponentData: { procedures: this.procedures },
        createEditComponentIsShown: true
      });
    }
  }
};
</script>

<style scoped></style>
